export default {
  groups: [],
  pagination: {},
  group: {}
}
